'use client';

import { Session } from 'next-auth';
import { redirect } from 'next/navigation';
import { useEffect } from 'react';

interface AgentsClientProps {
    session: Session;
}

export default function AgentsClient({ session }: AgentsClientProps) {
    useEffect(() => {
        // Redirect authenticated users to the nosagents dashboard
        if (session?.user?.email) {
            redirect('/nosagents');
        }
    }, [session]);

    // Fallback in case redirect doesn't work immediately
    return (
        <div className="flex items-center justify-center min-h-screen">
            <div className="text-center">
                <h1 className="text-2xl font-bold mb-4">Redirecting to NOS Agents...</h1>
                <p className="text-gray-600">If you're not redirected automatically, <a href="/nosagents" className="text-blue-600 hover:underline">click here</a>.</p>
            </div>
        </div>
    );
}
